import * as constants from '../constants/ActionTypes';

const initialState = {
  isModalOpen: false,
  channel: '',
  fromChannel: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOAD_MODAL_CONTAINER :
      return Object.assign({}, state, { isModalOpen: true, channel: action.payload });
    case constants.CLOSE_MODAL_CONTAINER :
      return Object.assign({}, state, { isModalOpen: false, channel: '' });
    case constants.LOGIN_CALLUS :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'callUs' });
    case constants.LOGIN_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'emailUs' });
    case constants.LOGIN_EMAIL_NO_INTENT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'email' });
    case constants.REQUEST_CALLUS :
    case constants.REQUEST_BY_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: '' });
    default:
      return state;
  }
}
